export type ErrorKey = 'CatalogPagination' | 'PlateOperators';

interface DictionaryFunctions {
	get(key: ErrorKey): string;
}

export const ErrorItems = (getValue: (key: string, defaultValue?: string) => string): DictionaryFunctions => {
	return {
		get: (key: ErrorKey): string => {
			switch (key) {
				case 'CatalogPagination':
					return getValue('Errors.CatalogPagination', 'Indtast et nummer inden for antallet af sider');
				case 'PlateOperators':
					return getValue('Errors.PlateOperators', 'Vi kunne desværre ikke finde nogen nummerpladeoperatør i byen/postnummeret.');
			}
		},
	};
};
